import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import { displayErrorToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { shiftListRequest } from '../../../redux/shift/shift.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import TopButton from "../../../components/button/top-button/topButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";

const ShiftList = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { shiftListSuccess, shiftListError } = useSelector(state => state.shift)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [selectedTab, setSelectedTab] = useState(0)

    const TAB_ITEMS = {
        ALL: 'ALL',
        MY_SHIFTS: 'MY SHIFTS'
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.SHIFT_LIST, true)
            fetchBusinessList()
        }
        if (isLoggedInUserEmployee(user) &&
            !isEmpty(employeeSelectedBusiness) &&
            !isEmpty(employeeSelectedLocation)) {
            fetchShift(0)
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.SHIFT_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.SHIFT_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(shiftListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(shiftListError)) {
            setLoading(false)
        }
    }, [shiftListSuccess, shiftListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
            fetchShift()
        }
    }, [selectedLocation])

    const fetchShift = (tabIndex) => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                data.locationId = selectedLocation.locationId
            }
        }
        if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
            data.locationId = employeeSelectedLocation
        }
        if (tabIndex === 1) {
            data.id = isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId
            data.userType = user.data.userDetails.userType
        }
        dispatch(shiftListRequest(data))
    }

    const handleAddShiftClick = () => {
        navigate(ROUTES.shift.add)
    }

    const handleViewDetail = element => {
        if (isLoggedInUserBusiness(user) && isNull(selectedBusiness) && isNull(selectedLocation)) {
            displayErrorToast('Business and location not selected')
        } else {
            navigate(ROUTES.shift.detail, {
                state: {
                    shiftId: element.shiftId,
                    businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation
                }
            })
        }
    }

    const handleTabSelect = (item) => {
        if (item === TAB_ITEMS.ALL) {
            setSelectedTab((prevTab) => {
                const newTab = 0
                fetchShift(0)
                return newTab
            })
        } else {
            setSelectedTab((prevTab) => {
                const newTab = 1
                fetchShift(1)
                return newTab
            })
        }
    }

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.SHIFT, PERMISSION_SUB_TYPE.SHIFT.ADD_SHIFT, employeeSelectedBusiness, employeeSelectedLocation)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Shifts' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {isLoggedInUserEmployee(user) && <div className="al-tab-row-container">
                    <div
                        className={`al-row-item-container ${selectedTab === 0 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.ALL) }}>{TAB_ITEMS.ALL}</div>
                    <div
                        className={`al-row-item-container ${selectedTab === 1 ? 'al-row-item-container-selected' : ''}`}
                        onClick={() => { handleTabSelect(TAB_ITEMS.MY_SHIFTS) }}>{TAB_ITEMS.MY_SHIFTS}</div>
                </div>}
                {!isNull(shiftListSuccess) && !isEmpty(shiftListSuccess.data) && <div className="table-scroll-container">
                    <table class="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Location</th>
                                <th scope="col" className="text-center">Date</th>
                                <th scope="col" className="text-center">Timings</th>
                                <th scope="col" className="text-center">Nomination Open</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shiftListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{element.name}</td>
                                    <td className="text-center">{!isEmpty(element.location) ? element.location.address : '-'}</td>
                                    <td className="text-center">{moment.utc(element.startDate).local().format('DD/MM/YYYY')} - {moment.utc(element.endDate).local().format('DD/MM/YYYY')}</td>
                                    <td className="text-center">{moment.utc(element.startTime).local().format('hh:mm A')} - {moment.utc(element.endTime).local().format('hh:mm A')}</td>
                                    <td className="text-center">
                                        <div className={element.openForNomination === true ? 'active' : 'in-active'}>{element.openForNomination === true ? 'Yes' : 'No'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className={element.isActive === true ? 'active' : 'in-active'}>{element.isActive === true ? 'Active' : 'In Active'}</div>
                                    </td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleViewDetail(element) }}><div className="tr-action-btn">View Details</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(shiftListError) && <div className="content-error">{shiftListError.message}</div>}
                {isPermissionAllowed() &&
                    <div className="vl-fab-container" onClick={() => handleAddShiftClick()}>
                        <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                    </div>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default ShiftList